var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobBreedenPilot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 280 280",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m279.5 279.52h-279l5-39 4.99-20.85 129.51-19.15 129.51 19.15 4.99 20.85z",
    fill: "#4f4f4f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m251.72 255.97h-223.58l-7.12-42.6 12.1-61.44 39.25 24.26h135.12l39.26-24.26 12.09 61.44z",
    fill: "#4f4f4f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m221.37 56.86-41.69-33.42h-77.88l-41.69 33.42-2.89 79.58 13.09 68.17h36.74 67.38 36.73l13.1-68.17z",
    fill: "#212121"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m248 310.52h-215.27l-17.69-97.29 125.32-14.11 125.32 14.11z",
    fill: "#2d2d2d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m154.78 47.91h-28.84l-50.82 31.42-4.11 60.02 7.54 63.87 39.6 23.88h44.43l39.44-23.88 7.7-81.55-4.11-42.34z",
    fill: "#333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m73.75 160.47 27.84 21.33 27.28 1.18-3.69 40.94-24.46-20.33-23.48-9.03z",
    fill: "#6d6d6d"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m208.4 130.1-68.04 27.75-68.04-27.75-4.45-28.19 72.49-45.43 72.49 45.43z",
    fill: "#f2eb00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m181.93 106.55-41.56 28.29-40.67-28.29-11.45-36.65 52.11-4.19 52.11 4.19z",
    fill: "#6d6d6d"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m206.59 160.47-27.84 21.33-27.28 1.18 3.69 40.94 24.46-20.33 23.52-9.03z",
    fill: "#6d6d6d"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m223.89 51.91-43.51-35.26h-80.04l-43.5 35.26-3 81.8 13.57 70.62h12.62l-14.24-56.83 14.86-48.58 33.8-28.76h51.83l33.8 28.76 14.86 48.58-14.25 56.83h12.62l13.57-70.62z",
    fill: "#2d2d2d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3d3d3d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m207.18 252.02-66.44 20-67.2-20-36.17-42.6 10.48-17.23 34-2.27 35.15 26.95 23.36 7.35 23.36-7.35 35.15-26.95 34 2.27 10.48 17.23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m163.91 70.16h-47.69l-15.2-54.68h78.09z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobBreedenPilot);
export default __webpack_public_path__ + "static/media/mob-breeden-pilot.2ad8681c5ccf3a98914bc3513984a575.svg";
export { ForwardRef as ReactComponent };